import type { IndicatorScope } from '@Application/Indicators/IndicatorScope';
import type { HomeScope } from '@UI/Pages/Home/Signals/homeScopeSignal';

/** `all` is the account scope: the server narrows it to the caller's own agencies. */
const resolveIndicatorScope = (scope: HomeScope, accountId: number): IndicatorScope => {
	switch (scope.kind) {
		case 'organization':
			return { kind: 'organization', organizationId: scope.id };
		case 'facility':
			return { kind: 'facility', facilityId: scope.id };
		case 'all':
			return { kind: 'account', accountId };
	}
};

export default resolveIndicatorScope;
